import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtAboutText from "./NtAboutText";
import NtAboutTextBold from "./NtAboutTextBold";
import NtAboutTextBullet from "./NtAboutTextBullet";
import NtText from "../../../components/NtText";
import NtTouchableEffect from "../../../components/NtTouchableEffect";

function NtAboutSectionInfo(props) {
  const renderLogo = (containerStyle, imageStyle, image, onPress) => {
    return (
      <NtTouchableEffect style={containerStyle} onPress={onPress}>
        <Image style={[imageStyle]} source={image} />
      </NtTouchableEffect>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <NtAboutText>
        <NtAboutTextBold>
          NT Connect Holdings, Inc. (NT Connect)
        </NtAboutTextBold>
        , established in 2018, is a leading provider of communication
        intelligence and IT solutions, specializing in building and managing
        mission-critical communication networks. We empower consumers,
        government agencies, enterprise organizations, and maritime operators
        with advanced, secure, and scalable technologies that keep people
        connected anywhere in the world.{"\n\n"}Our services include LEO
        satellite connectivity, location-based services, contact tracing, access
        control systems, cutting-edge telehealth technologies, and robust VoIP
        solutions for both consumers and businesses. Our diverse client base
        includes the Department of Defense, Canadian Coast Guard, Cunard Line,
        Disney Cruise Line, Holland America / Princess, Westmark Hotels, Hilton
        Hotels, Norwegian Cruise Line, and P&O Cruises.{"\n\n"}
        <NtAboutTextBold>Core Competencies</NtAboutTextBold>
      </NtAboutText>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        Interconnected VoIP solutions
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        VoIP services for consumers and businesses
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        POTS to SIP modernization
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        Enterprise-grade deployments
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        Unified Communications (UCaaS)
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        TDM to IP hardware deployments
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        On-premises and cloud PBX solutions
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        API and middleware development
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        Enterprise-grade DevOps & DevSecOps (CI/CD/IaC)
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        Mobile application development
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        Cloud-native and hybrid cloud support
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        SMS over IP, RCS, XMPP, AMQP, MQTT, WebRTC
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        Apple Push Notifications, Google Firebase Cloud Messaging
      </NtAboutTextBullet>

      <NtAboutText style={{ marginTop: 20 }}>
        <NtAboutTextBold>Differentiators</NtAboutTextBold>
        {"\n\n"}
        NT Connect delivers secure, reliable communication systems tailored for
        government, enterprise, maritime, and consumer sectors. Our expertise in
        air-gapped maritime environments seamlessly extends to land-based and
        commercial projects, enabling us to create highly customized,
        user-friendly solutions even in the most challenging and remote
        conditions.{"\n\n"}
        <NtAboutTextBold>Why Choose NT Connect?</NtAboutTextBold>
        {"\n\n"}We maximize ROI by leveraging your existing equipment, ensuring
        your initial investment is preserved while seamlessly modernizing
        backend infrastructure for enhanced performance and scalability. Our
        proven Methodology Framework — from discovery through deployment to
        ongoing support — ensures quality control, clear expectations, and
        on-time delivery.{"\n\n"}NT Connect’s secure and customizable solutions
        consistently deliver high-quality results in complex, mission-critical
        environments. With deep technical expertise and a strong track record,
        we are the trusted partner organizations and individuals rely on to stay
        connected and secure.{"\n\n"}
        <NtAboutTextBold>Our Mission</NtAboutTextBold>
        {"\n\n"}To empower organizations and individuals worldwide with secure,
        innovative, and reliable communication solutions that enable them to
        connect, collaborate, and thrive — anywhere, anytime.{"\n\n"}{" "}
        <NtAboutTextBold>Our Vision</NtAboutTextBold>
        {"\n\n"}To be the global leader in mission-critical communication
        technology, bridging people and systems across land, sea, and air, while
        setting new standards for security, flexibility, and performance.
        {"\n\n"} <NtAboutTextBold>Our Valuess</NtAboutTextBold>
      </NtAboutText>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        <NtAboutTextBold>Innovation:</NtAboutTextBold> We continually push
        boundaries to deliver cutting-edge solutions.
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        <NtAboutTextBold>Integrity:</NtAboutTextBold> We act with transparency,
        honesty, and accountability in everything we do.
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        <NtAboutTextBold>Reliability:</NtAboutTextBold> We ensure our solutions
        work where and when they are needed most.
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        <NtAboutTextBold>Customer Focus:</NtAboutTextBold> We tailor every
        solution to the unique needs of our clients and end users.
      </NtAboutTextBullet>

      <NtAboutTextBullet containerStyle={{ marginTop: 20 }}>
        <NtAboutTextBold>Excellence:</NtAboutTextBold> We are committed to
        delivering exceptional quality in every project.
      </NtAboutTextBullet>

      <NtAboutText style={{ marginTop: 20 }}>
        <NtAboutTextBold>Also from NT Connect</NtAboutTextBold>
      </NtAboutText>

      <View style={{ flexDirection: "row", marginTop: 20 }}>
        {renderLogo(
          {},
          { width: 130, height: 60, resizeMode: "contain" },
          require("../../../assets/images/partners/logo-nooz.png"),
          () => {
            window.open("https://nooz.ai/app");
          }
        )}

        {renderLogo(
          { marginLeft: 20, marginTop: -17 },
          { width: 150, height: 80, resizeMode: "contain" },
          require("../../../assets/images/nt-maritime-logo-white.png"),
          () => {
            window.open("https://ntmaritime.com");
          }
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtAboutSectionInfo;
